module.exports = __webpack_public_path__ + "static/img/nowhere.f6da33ba.svg";